document.addEventListener("DOMContentLoaded", function() {
  var collection_dropdown = document.querySelector('[data-tag-filter-mobile-trigger]');
  if (collection_dropdown) {
    const observer = new IntersectionObserver( 
      ([e]) => e.target.parentElement.classList.toggle('stuck', e.intersectionRatio < 1),
      {threshold: [1]}
    );

    observer.observe(collection_dropdown);    

    collection_dropdown.addEventListener('click', function(e) {
      e.preventDefault();

      var collection_dropdown_menu = document.querySelector('[data-tag-list]');

      collection_dropdown.classList.toggle('active');
      collection_dropdown_menu.classList.toggle('md--dn--hide');
    });
  }


  var thumbnails = document.querySelectorAll('[data-product-single-thumbnail]');
  if(thumbnails && thumbnails.length > 0) {
    thumbnails.forEach(function(thumbnail) {
      var image = thumbnail.querySelector('.responsive-image__wrapper');
      var image_id = image.getAttribute('data-image-id');
      
      const featured_image = document.querySelector('[data-raw-image-id="' + image_id + '"]');

      thumbnail.addEventListener('click', function(e) {
        e.preventDefault();

        var image_top = featured_image.offsetTop;
        window.scrollTo(0, image_top - 70);

        // jquery_default()("body,html").animate(
        //   {
        //     scrollTop: target_image.offset().top - 18
        //   },
        //   800
        // );

        // 
      });
    });
  }
});